var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.875,
    y: 11.875,
    width: 29.6875,
    height: 29.6875,
    rx: 5.9375,
    fill: "#E0E0E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.875,
    y: 53.4375,
    width: 29.6875,
    height: 29.6875,
    rx: 5.9375,
    fill: "#E0E0E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4375,
    y: 11.875,
    width: 29.6875,
    height: 29.6875,
    rx: 5.9375,
    fill: "#E0E0E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2812 53.4375C60.0875 53.4375 53.4375 60.0875 53.4375 68.2812C53.4375 76.475 60.0875 83.125 68.2812 83.125C76.475 83.125 83.125 76.475 83.125 68.2812C83.125 60.0875 76.475 53.4375 68.2812 53.4375ZM74.241 69.7211H69.7211V74.241C69.7211 75.0389 69.0791 75.6809 68.2812 75.6809C67.4834 75.6809 66.8414 75.0389 66.8414 74.241V69.7211H62.3215C61.5236 69.7211 60.8816 69.0791 60.8816 68.2812C60.8816 67.4834 61.5236 66.8414 62.3215 66.8414H66.8414V62.3215C66.8414 61.5236 67.4834 60.8816 68.2812 60.8816C69.0791 60.8816 69.7211 61.5236 69.7211 62.3215V66.8414H74.241C75.0389 66.8414 75.6809 67.4834 75.6809 68.2812C75.6809 69.0791 75.0352 69.7211 74.241 69.7211Z",
    fill: "#E0E0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b8945e1e4ce76e333513a38ca30ad388.svg";
export { ForwardRef as ReactComponent };